module.exports = __webpack_public_path__ + "img/everyday.d5abec0f.png";